import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';
import { Button, DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const DropdownWrapper = styled('div')`
  margin-left: -11px;
`;

export const ButtonWrapper = styled('div')<{ active?: boolean }>`
  display: inline-block;
  background: ${({ theme, active }) => active && theme.color.whiteRGBA(0.05)};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
`;

export const ViewType = styled(Button)`
  border-radius: 100%;
`;

export const Meta = styled(Grid)`
  padding: ${({ theme }) => `${theme.x2spacePx - 6}px 0`};
`;

export const TotalRecords = styled('span')`
  ${({ theme }) => theme.typography.tiny};
  color: ${({ theme }) => theme.color.whiteRGBA(0.3)};
`;

export const Wrapper = styled(Grid)`
  border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  margin-bottom: -1px;
  padding: ${({ theme }) => `${theme.x2spacePx}px ${theme.x2spacePx}px`};
  ${media.lgUp`
			padding: ${({ theme }) => `0 0 ${theme.x1spacePx}px`};
	`};
`;
